/* eslint-disable max-len */
import { IconProps } from 'models/icons';
import React from 'react';

const RejectIcon: React.FC<IconProps> = ({ ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.5C14.6942 1.50019 18.4999 5.30577 18.5 10C18.4998 14.6941 14.6941 18.4998 10 18.5C5.30585 18.4998 1.50019 14.6941 1.5 10C1.50008 5.30577 5.30579 1.50018 10 1.5ZM5.5166 15.4834C6.73787 16.483 8.29883 17.0829 10 17.083C13.9117 17.0828 17.0828 13.9117 17.083 10C17.083 8.29904 16.4827 6.73879 15.4834 5.51758L5.5166 15.4834ZM10 2.91602C6.08819 2.91619 2.9161 6.08817 2.91602 10C2.9161 11.7008 3.51632 13.2614 4.51562 14.4824L14.4824 4.51562C13.2614 3.51633 11.7007 2.9161 10 2.91602Z"
        fill={props.color ?? props?.style?.color}
      />
    </svg>
  );
};

export default RejectIcon;
